import styles from "./Error.module.css";
import Modal from "./Modal";

export default function Error({ message, action, onClose }) {
    return (
        <Modal onClose={onClose}>
            <div className={styles.content}>
                <div className={styles.title}>{message}</div>
                <div className={styles.actions}>
                    <div onClick={onClose} className={styles.button}>
                        {action}
                    </div>
                </div>
            </div>
        </Modal>
    );
}
